import { render, staticRenderFns } from "./tallaParaLaEdadNinas2a5A.vue?vue&type=template&id=4d00cffe&scoped=true&"
import script from "./tallaParaLaEdadNinas2a5A.vue?vue&type=script&lang=js&"
export * from "./tallaParaLaEdadNinas2a5A.vue?vue&type=script&lang=js&"
import style0 from "./tallaParaLaEdadNinas2a5A.vue?vue&type=style&index=0&id=4d00cffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d00cffe",
  null
  
)

export default component.exports